import { StageType } from './stage-type';

export const environment = {
  production: true,
  isConnectToBackend: true,
  isDebugMode: false,
  stageType: StageType.staging,

  isE2e: false,

  textFieldDebounceTime: 32,

  enableNextTaskDetail: true,

  accessToken: '',

  domain: 'https://webapp.360interview.com',

  ec2Url: '<TODO>',

  lambdaWebsiteUrl: 'https://uzzbu5madzwpkavbqglwb7ootm0nzjbn.lambda-url.us-east-2.on.aws/',
  lambdaWebsitePublicUrl: 'https://wv3m6o7i6oxczq3vmnnq7dfuti0lmkev.lambda-url.us-east-2.on.aws/',
  openaiUrl: 'https://zkqw7ai2yo6nbqwblt3oxsqfzq0ocref.lambda-url.us-east-2.on.aws/',

  lambdaWebSocketUrl: 'wss://dhloiqq3mb.execute-api.us-east-2.amazonaws.com/prod',

  clerkKey: 'pk_live_Y2xlcmsuMzYwaW50ZXJ2aWV3LmFpJA',

  sentry: 'https://f541c29cf2b73a756f2badc2e9cfbc24@o4507196929015808.ingest.us.sentry.io/4507242193879040',
  posthog: 'phc_4XiYFScfFA4BqlcUv6RZor6ckU0UaR3rAeEs1xXZkGd',

  posthogSurvey: {
    interviewEndSurvey: '018fbc7d-3c26-0000-5dd8-47fdbd6efddd',
  },

  stripe: {
    pricingTableId: 'prctbl_1Pa4UrRsOXpuonKvLzbgXdEO',
    publishableKey:
      'pk_live_51PI0NuRsOXpuonKvOWNiFNF4z4W0dLD8Hz3GCyQL4SbwJPdx1UQZEuZ582evmYeDIAX30kRuHe5BJFuLPpC8toTT00spOrdR7H',
  },
};
